<template>
  <v-list-group :prepend-icon="item.icon" no-action>
    <template v-slot:activator>
      <v-list-item-content>
        <v-list-item-title>{{ item.text }}</v-list-item-title>
      </v-list-item-content>
    </template>

    <div v-for="(child, x) in item.children" :key="x">
      <v-list-item
        :to="child.route"
        class="pl-8"
        v-can:permission="child.permission"
      >
        <v-list-item-icon>
          <v-icon>{{ child.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ child.text }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </div>
  </v-list-group>
</template>

<script>
export default {
  name: "MenuLevel",

  props: {
    item: {
      type: Object,
    },
  },
};
</script>
<style scoped>
a {
  text-decoration: none;
}

/deep/.theme--light.v-list-item:not(.v-list-item--active):not(.v-list-item--disabled) {
  color: rgba(255, 255, 255, 0.5) !important;
}

.v-list--dense .v-list-item .v-list-item__icon {
  color: rgba(255, 255, 255, 0.5) !important;
}

.v-application .primary--text {
  color: #fff !important;
}

.theme--light.v-list-item {
  color: #fff !important;
}

.theme--light.v-icon {
  color: rgba(255, 255, 255, 0.5) !important;
}

.v-list-item--active >>> .theme--light.v-icon  {
  color: #fff !important;
}

/deep/.v-list-item__icon {
  color: #fff !important;
}

/deep/.v-list-group__header__prepend-icon {
  color: #fff !important;
}

/deep/.v-icon.v-icon{
  color: rgba(255, 255, 255, 0.5) !important;
}

</style>
